import { render, staticRenderFns } from "./edit-main-sale-invoice.vue?vue&type=template&id=5625e072&"
import script from "./edit-main-sale-invoice.vue?vue&type=script&lang=js&"
export * from "./edit-main-sale-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports